import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import NlpLanguageSettings from './NlpLanguageSettings';
import $ from 'jquery';

class NlpProjectSettings extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-nlp/";
      var path1 = window.origin + "/platform/cloud-nlp";
      if (currentPath === path || currentPath === path1) {
        $("#language-tab").addClass('active');
      }

      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#language-tab,#apicred-tab")
        .on("click", function () {
          $("#language-tab,#apicred-tab")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">NLP API Settings</h1>
                  <h6 className="taglineTxt">Agent Configurations</h6>
                </div>

              </div>
            </div>
          </div>
          <div className="container-fluid" >
            <div className="border-bottom"></div>

            {/* Nav tabs */}
            <div className="d-flex p-0 border-bottom">

              <ul className="nav nav-pills mr-auto" >
                <Link className="nav-item" to="/cloud-nlp" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="language-tab">
                    Language
                  </li></Link>

              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/cloud-nlp" component={NlpLanguageSettings}></Route>
        </Switch>
      </div>

    );
  }
}
export default NlpProjectSettings;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpProjectSettings.js